import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error400: false,
  error: '',
  successFlag: false,
  token: '',
  allAttachments: [],
};
const getters = {
  getApiLoad_121: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_AllAttachments(state, allAttachments) {
    state.allAttachments = allAttachments;
  },
};
const actions = {
  errorAttachment({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getAllAttachmentsDispatch({ commit, dispatch, rootState }, params) {
    return apiClient
      .get('/ChiefComplaintAttachments/All', {
        params,
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllAttachments', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorAttachment', error);
      });
  },
  addRangeOfAttachmentsDispatch({ commit, dispatch, rootState }, body) {
    return apiClient
      .post('/ChiefComplaintAttachments/Range', body, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        // commit("SET_AllAttachments", response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorAttachment', error);
      });
  },
  //   getAllActiveAttachments({ commit, dispatch, rootState }, params) {
  //     return apiClient
  //       .get("/ChiefComplaintTriageAttachments/AllActive", {
  //         params,
  //         headers: { "X-CSRF-Token": rootState.loginModule.csrf },
  //       })
  //       .then((response) => {
  //         commit("SET_AllActiveAttachments", response.data);
  //         commit("SET_Status", true);
  //       })
  //       .catch((error) => {
  //         dispatch("errorAnswer", error);
  //       });
  //   },
  //   createAnswer({ commit, dispatch, rootState }, body) {
  //     return apiClient
  //       .post("/ChiefComplaintTriageAttachments", body, {
  //         headers: { "X-CSRF-Token": rootState.loginModule.csrf },
  //       })
  //       .then(() => {
  //         commit("SET_Status", true);
  //       })
  //       .catch((error) => {
  //         dispatch("errorAnswer", error);
  //       });
  //   },
  // getAnswer({ commit, dispatch, rootState }, params) {
  //       return apiClient
  //         .get("/ChiefComplaintTriageAttachments/ById", {
  //           params,
  //           headers: { "X-CSRF-Token": rootState.loginModule.csrf },
  //         })
  //         .then((response) => {
  //           commit("SET_Answer", response.data);
  //           commit("SET_Status", true);
  //         })
  //         .catch((error) => {
  //           dispatch("errorAnswer", error);
  //         });
  // },
  //   editAnswer({ commit, dispatch, rootState }, body) {
  //     return apiClient
  //       .post("/ChiefComplaintTriageAttachments/Edit", body, {
  //         headers: { "X-CSRF-Token": rootState.loginModule.csrf },
  //       })
  //       .then(() => {
  //         commit("SET_Status", true);
  //       })
  //       .catch((error) => {
  //         dispatch("errorAnswer", error);
  //       });
  //   },
  //   deleteAnswer({ commit, dispatch, rootState }, params) {
  //     return apiClient
  //       .post("/ChiefComplaintTriageAttachments/Remove", null, {
  //         params,
  //         headers: { "X-CSRF-Token": rootState.loginModule.csrf },
  //       })
  //       .then(() => {
  //         commit("SET_Status", true);
  //       })
  //       .catch((error) => {
  //         dispatch("errorAnswer", error);
  //       });
  //   },
  //   activeAnswer({ commit, dispatch, rootState }, params) {
  //     return apiClient
  //       .post("/ChiefComplaintTriageAttachments/Activate", null, {
  //         params,
  //         headers: { "X-CSRF-Token": rootState.loginModule.csrf },
  //       })
  //       .then(() => {
  //         commit("SET_Status", true);
  //       })
  //       .catch((error) => {
  //         dispatch("errorAnswer", error);
  //       });
  //   },
  //   deactivateAnswer({ commit, dispatch, rootState }, params) {
  //     return apiClient
  //       .post("/ChiefComplaintTriageAttachments/Deactivate", null, {
  //         params,
  //         headers: { "X-CSRF-Token": rootState.loginModule.csrf },
  //       })
  //       .then(() => {
  //         commit("SET_Status", true);
  //       })
  //       .catch((error) => {
  //         dispatch("errorAnswer", error);
  //       });
  //   }
};
export default {
  mutations,
  getters,
  state,
  actions,
};
